import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取地址列表
export function getMailingAddressList(data) {
  return request({
    url: URL.mdm.fbaMailingAddress.queryMailingAddress,
    method: 'post',
    data
  })
}

// 通过uuid获取收发通地址,用于编辑前查值
export function findMailingAddressByUuid(data) {
  return request({
    url: URL.mdm.fbaMailingAddress.mailingAddressDetail,
    method: 'post',
    data
  })
}

export function addMailingAddress(data) {
  return request({
    url: URL.mdm.fbaMailingAddress.mailingAddressInfo,
    method: 'post',
    data
  })
}

export function updateMailingAddress(data) {
  return request({
    url: URL.mdm.fbaMailingAddress.mailingAddressInfo,
    method: 'put',
    data
  })
}

// 删除
export function batchDelMailingAddress(data) {
  return request({
    url: URL.mdm.fbaMailingAddress.mailingAddressInfo,
    method: 'delete',
    data
  })
}
